export const SIGNED_OUT_KEY = "app_signed_out";

export function markSignedOut() {
  try {
    localStorage.setItem(SIGNED_OUT_KEY, "true");
  } catch (e) {
    console.warn("Impossibile salvare il flag di signout:", e);
  }
}

export function wasSignedOut(): boolean {
  try {
    return localStorage.getItem(SIGNED_OUT_KEY) === "true";
  } catch {
    return false;
  }
}

export function clearAppStorage() {
  try {
    localStorage.clear();
  } catch (e) {
    console.warn("Error cleaning localStorage:", e);
  }

  try {
    sessionStorage.clear();
  } catch (e) {
    console.warn("Error cleaning  sessionStorage:", e);
  }

  try {
    const cookies = document.cookie.split(";");
    for (const cookie of cookies) {
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie =
        name.trim() + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
    }
  } catch (e) {
    console.warn("Error cleaning cookie", e);
  }
}
